import { render, staticRenderFns } from "./m-about.vue?vue&type=template&id=70fc1a59"
import script from "./m-about.vue?vue&type=script&lang=js"
export * from "./m-about.vue?vue&type=script&lang=js"
import style0 from "./m-about.vue?vue&type=style&index=0&id=70fc1a59&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports